import axios from "./axios-handler.service";
const BASE_URL = "/api/login";

export interface LoginCommand {
  email: string;
  senha: string;
}

export class LoginService {
  static rolesPromise: Promise<string[]> | null = null;

  static async login(body: LoginCommand, returnUrl?: string) {
    const response = await axios.post(`${BASE_URL}/entrar`, body, {
      params: { returnUrl },
    });

    await this.GetRoleUsuario();

    return response.data;
  }

  static async logOut(): Promise<void> {
    await axios.get(`${BASE_URL}/sair`);
    this.rolesPromise = null;
  }

  static async GetRoleUsuario(): Promise<string[]> {
    return this.rolesPromise = (this.rolesPromise ||
      axios.get<string[]>(`${BASE_URL}/ObterRoles`)
        .then(reseponse => reseponse.data));
  }
}
